import {getRequest, getRequestFile, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des faire-part de décès
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprDecesTemplateList = (token) => {
    const url = `/api-v1/fpr/deces/template/list`
    return getRequest(url, token)
};

/**
 * Lecture des données enregistrées pour un faire-part de décès d'un défunt.
 *
 * @param string $token Jeton d'authentification.
 * @param string $id Identifiant du défunt.oir rsultat
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprDecesDataSaved = (token, id) => {
    const url = `/api-v1/fpr/deces/${id}/last/data`
    return getRequest(url, token)
};

/**
 * Lecture de la liste des textes pour un faire-part de décès.
 *
 * @param int $elementType Type d'élément.
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprContentList = (token, type) => {
    const url = `/api-v1/fpr/text/${type}/list`
    return getRequest(url, token)
};

/**
 * Lecture de la liste des symboles enabled pour un faire-part de décès.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprSymbolList = (token) => {
    const url = `/api-v1/fpr/symbol/list`
    return getRequest(url, token)
}

/**
 * Lecture de la liste des intervenants pour un faire-part de décès.
 *
 * @param string $token Jeton d'authentification.
 * @param string $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprDecesIntervenantList = (token, id) => {
    const url = `/api-v1/fpr/intervenants/${id}/list`
    return getRequest(url, token)
};

/**
 * Lectude de la liste des textes concernant les informations de décès pour un faire-part de décès.
 *
 * @param string $token Jeton d'authentification.
 * @param string $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprDecesInfoDecesList = (token, id) => {
    const url = `/api-v1/fpr/deces/${id}/list`
    return getRequest(url, token)
}

/**
 * Impression d'un faire-part de décès.
 *
 * @param string $token Jeton d'authentification.
 * @param string $deceasedId Identifiant du défunt.
 * @param string $id Identifiant du défunt.
 */
export const getFprPrint = (token, deceasedId, type) => {
    const url = `/api-v1/fpr/${deceasedId}/${type}/print`
    return getRequestFile(url, token)
};

/** Suppression d'un faire-part PDF.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Type de faire-part.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const deleteFprFileFromDb = (token, id) => {
    const url = `/api-v1/fpr/${id}/delete`
    return getRequest(url, token)
};

/************************** Remerciements **************************/

/**
 * Récupération de la liste des faire-part de remerciements.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprRemerciementTemplateList = (token) => {
    const url = `/api-v1/fpr/remerciement/template/list`
    return getRequest(url, token)
};

/**
 * Lecture des données enregistrées pour un faire-part de remerciements d'un défunt.
 *
 * @param string $token Jeton d'authentification.
 * @param string $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprRemerciementDataSaved = (token, id) => {
    const url = `/api-v1/fpr/remerciement/${id}/last/data`
    return getRequest(url, token)
};

/**
 * Lecture des textes d'introduction pour un faire-part.
 *
 * @param string $token Jeton d'authentification.
 * @param int $elementType Type d'élément.
 * @param string $typeFpr Type de faire-part (décès ou remerciement).
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getIntroductionTextList = (token, elementType, typeFpr) => {
    const url = `/api-v1/fpr/introduction/${typeFpr}/${elementType}/list`
    return getRequest(url, token)
};

/**
 * Lecture de la liste des textes pour un faire-part de remerciements.
 *
 * @param string $token Jeton d'authentification.
 * @param int $elementType Type d'élément.
 * @param string $typeFpr Type de faire-part (décès ou remerciement).
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getRemerciementTextList = (token, elementType, typeFpr, deceasedId) => {
    const url = `/api-v1/fpr/remerciement/${deceasedId}/${typeFpr}/${elementType}/list`
    return getRequest(url, token)
}

/**
 * Sauvegarde du choix de template pour un faire-part.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Données à sauvegarder.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const saveTemplate = (token, body) => {
    const url = `/api-v1/fpr/template/save`
    return postRequest(url, body, token)
};

/**
 * Sauvegarde des données pour un faire-part.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Données à sauvegarder.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const saveFprData = (token, body) => {
    const url = `/api-v1/fpr/data/save`
    return postRequest(url, body, token)
};

/**
 * Lecture d'un faire-part fichier PDF.
 *
 * @param string $token Jeton d'authentification.
 * @param string $id Identifiant du défunt.
 * @param string $type Type de faire-part.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getFprFile = (token, id, type) => {
    const url = `/api-v1/fpr/${id}/${type}/file`
    return getRequest(url, token)
};

/**
 * Enregistrement d'un fichier PDF pour un faire-part.
 *
 * @param string $token Jeton d'authentification.
 * @param string $id Identifiant du faire-part.
 * @param deceasedId Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const uploadFprPdf = (token, body) => {
    const url = `/api-v1/fpr/file/upload`
    return postRequest(url, body, token)
};
